import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-empty",
  "use": "icon-empty-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-empty\">\n  <path d=\"M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm392 448c0 98-36.4 187.5-96.1 256.3L255.7 216.1C324.5 156.4 414 120 512 120c216.1 0 392 175.9 392 392zm-784 0c0-98 36.4-187.5 96.1-256.3l552.2 552.2C699.5 867.6 610 904 512 904c-216.1 0-392-175.9-392-392z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol